import React from 'react';

const Badge = ({ children, className = '', variant = 'default', ...props }) => {
    const variants = {
        default: 'bg-sm-primary text-white hover:bg-sm-primary/80',
        secondary: 'bg-sm-secondary text-secondary-foreground hover:bg-sm-secondary/80',
        destructive: 'bg-destructive text-white hover:bg-destructive/80',
        outline: 'text-foreground border border-input hover:bg-accent hover:text-accent-foreground',
    };

    return (
        <div
            className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 ${variants[variant] || variants.default} ${className}`}
            {...props}
        >
            {children}
        </div>
    );
};

export { Badge };
